import * as React from "react";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Button, Container, Tab } from "@mui/material";
import { ProductType } from "../types/types";
import { parseCsvFile } from "../utils/parseCsv";
import { Product } from "../types/product";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { slugify } from "../utils/generalFunction";
const Row = (item: { [key: string]: any }) => {
  const [open, setOpen] = React.useState(false);
  const [featuredProducts, setFeaturedProducts] = React.useState<Product[]>([]);
  React.useEffect(() => {
    parseCsvFile("/data/fpdl.csv").then((featuredProducts) => {
      setFeaturedProducts(featuredProducts);
    });
  }, []);
  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell className="w-10">
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row" className="!font-bold">
          {item.name}
        </TableCell>
        <TableCell />
        <TableCell className="w-1" />
        <TableCell className="!w-1/2" align="right">
          <Button
            endIcon={<ArrowForwardIosIcon />}
            sx={{ textTransform: "none", width: "120px" }}
            href={"products?category=" + slugify(item.name)}
          >
            Xem tất cả
          </Button>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Table size="small" aria-label="purchases">
                <TableBody>
                  {featuredProducts.map((product) => (
                    <TableRow key={product.id}>
                      <TableCell className="!w-10" />
                      <TableCell className="!w-1/2" component="th" scope="row">
                        {product.name}
                      </TableCell>
                      <TableCell className="!w-1/4">
                        {product.priceSale}
                      </TableCell>
                      <TableCell className="!w-1/4" align="right">
                        {product.brandName}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

const PricePage: React.FC = () => {
  return (
    <Container className="!w-5/6 !py-10">
      <Typography variant="h4" className="text-center mb-6 font-bold">
        Bảng báo giá máy lạnh chính hãng
      </Typography>
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow className="bg-primary_blue ">
              <TableCell className="!w-10" />
              <TableCell className="!w-1/2 !font-bold !text-white">
                Sản phẩm
              </TableCell>
              <TableCell className="!w-1/4 !font-bold !text-white" align="left">
                Giá bán
              </TableCell>

              <TableCell />
              <TableCell
                className="!w-1/4 !font-bold !text-white"
                align="right"
              >
                Thương hiệu
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {ProductType.map((row) => (
              <Row name={row} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default PricePage;
